/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Could_Not_Start_ChatInputs */

const en_mobile_could_not_start_chat = /** @type {(inputs: Mobile_Could_Not_Start_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start chat. Please try again later.`)
};

const es_mobile_could_not_start_chat = /** @type {(inputs: Mobile_Could_Not_Start_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo iniciar el chat. Por favor, inténtalo más tarde.`)
};

/**
* | output |
* | --- |
* | "Could not start chat. Please try again later." |
*
* @param {Mobile_Could_Not_Start_ChatInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_could_not_start_chat = /** @type {((inputs?: Mobile_Could_Not_Start_ChatInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Could_Not_Start_ChatInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_could_not_start_chat(inputs)
	return en_mobile_could_not_start_chat(inputs)
});